export default __webpack_public_path__ + "static/N0291-aeea9d5146925f776945be734e1467a5.png";